import React from 'react';

import { Wrapper } from './styles';

export const PaginationContainer: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
